module.exports = __webpack_public_path__ + "media/stylesheets/images/スクリーンショット 2022-07-03 1.25 1-91201c9227af709403fd5e66a84e9033.jpg";